import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from 'components/SVGIcon';
import { ReactComponent as DefaultIcon } from './icon-magnifying-glass.svg';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    callback: PropTypes.func.isRequired,
    icon: PropTypes.func,
    active: PropTypes.bool,
};

const defaultProps = {
    icon: DefaultIcon,
    active: false,
};

/*
 * Component
 */
function ButtonWithIcon({ callback, icon, active }) {
    const Icon = icon;

    let classes = 'button-with-icon';
    if (active) {
        classes += ' active';
    }

    return (
        <button className={classes} type="button" onClick={callback}>
            <SVGIcon icon={Icon} />
        </button>
    );
}

ButtonWithIcon.propTypes = propTypes;
ButtonWithIcon.defaultProps = defaultProps;

export default ButtonWithIcon;
